import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";

// Component
import LanguageIcon from "@mui/icons-material/Language";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";

// Constants
import { APP_CONSTANTS } from "constants";

// Redux
import { setWebConfigAction } from "redux/core/actions";

const ChooseLanguage = () => {
  const dispatch = useDispatch();
  const router = useRouter();

  // read current lang from Redux (falls back to router or 'fa')
  const { webConfig } = useSelector((state) => state.core) || {};
  const currentLang =
    webConfig?.lang || (router.query?.lang ? String(router.query.lang) : "fa");

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectLang = (lang) => {
    handleClose();

    const t = APP_CONSTANTS.WEB_CONFIG.filter((t) => t.lang === lang);
    if (t?.[0]) dispatch(setWebConfigAction(t[0]));

    // keep `lang` in the URL (omit for 'fa')
    const queryLang = lang === "fa" ? "" : lang;
    let query;
    if (queryLang !== "") {
      query = { ...router.query, lang: queryLang };
    } else {
      const { lang: _omit, ...rest } = router.query;
      query = { ...rest };
    }

    router.replace({
      pathname: router.pathname,
      query,
    });
  };

  // Small label text to show left of the icon
  const changeLangLabel =
    currentLang === "fa"
      ? "EN"
      : currentLang === "en"
      ? "FA"
      : String(currentLang).toUpperCase();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* Small label on the LEFT of the icon */}

      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <span
          style={{
            fontSize: 10,
            fontStyle: "oblique",
            fontWeight: "bold",
            userSelect: "none",
            lineHeight: 1,
          }}
          aria-hidden="true"
        >
          {changeLangLabel}
        </span>
        <LanguageIcon className="icon" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 64,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
      >
        <MenuItem
          selected={currentLang === "fa"}
          onClick={() => handleSelectLang("fa")}
        >
          فارسی
        </MenuItem>
        <MenuItem
          selected={currentLang === "en"}
          onClick={() => handleSelectLang("en")}
        >
          English
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ChooseLanguage;
